import React, { useEffect } from 'react'
import imgMeasurement from '../../assets/news-events/Measurement.png'
import ImageDescription from '../../Components/ImageDescription/ImageDescription'
import TextCaption from '../../Components/TextCaption/TextCaption'
import SectionHeader from '../../Components/SectionHeader/SectionHeader'
import imgMeasurement_01 from '../../assets/news-events/Measurement_01.png'
import imgMeasurement_02 from '../../assets/news-events/Measurement_02.png'
import imgMeasurement_03 from '../../assets/news-events/Measurement_03.png'


const Measurement = () => {

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    return (
        <div>
            <ImageDescription
                imageSrc={imgMeasurement}
                title={"Essential Tools for Hydraulic Measurement"}
                paragraphs={[
                    "Anyone who has ever needed to identify a hydraulic connection on a daily basis knows: you can't rely on your eye alone. A wrong measurement or hastily made identification can cause rework, delays and even greater losses if the wrong part is installed. And look, often, the difference between one connection and another is minimal — but it makes all the difference in the system."
                    , "Text: Gabriela Nascimento and Tatiana Schrader, May 28, 2025", "Therefore, having the right tools at hand is the first step to avoid headaches and save time. At HANSA-FLEX, we believe that knowledge and preparation are as important as the equipment. If you work with hoses, connections, adapters or hydraulic systems in general, stay here with us and we will show you how to assemble a basic and efficient kit to measure and identify parts safely and quickly.."
                ]}
            />

            <TextCaption

                paragraph="Therefore, having the right tools at hand is the first step to avoid headaches and save time. At HANSA-FLEX, we believe that knowledge and preparation are as important as the equipment. If you work with hoses, connections, adapters or hydraulic systems in general, stay here with us and we will show you how to assemble a basic and efficient kit to measure and identify parts safely and quickly."
            />


            <TextCaption
                title="Caliper: your best friend on the bench"
                paragraph="If there is a tool that cannot be missing, it is the caliper. It is responsible for accurately measuring external and internal diameters and even depth of parts. That is, he is the one who will tell you if that connection is 15, 16 or 17 mm in diameter — because, in the eye, it is almost impossible to know."
            />

            <TextCaption

                paragraph="There are several models: analog, digital, with clock... But the most practical for everyday life is digital, especially for those who are just starting out. The reading is direct, fast and avoids confusion. At HANSA-FLEX, we use calipers with a minimum resolution of 0.05 mm, which ensures more accuracy. With it, you already take an important step to identify the right part and avoid mistakes when replenishing."
            />

            <ImageDescription
                imageSrc={imgMeasurement_01}
                title={"Thread Comb: the secret is in the step"}
                paragraphs={[
                    "The screw comb looks simple, but it is one of the smartest tools in your briefcase. It helps to find out the thread pitch — that is, the distance between the threads. This may seem like a detail, but it is this 'detail' that determines whether the part is BSP, metric, JIC, NPT, among others."
                    , "The comb has two sides: one for metric threads (with measurements such as 1.25 or 1.5 mm) and another for inches, with threads per inch (14, 16, 18 threads, for example). The idea is to fit the teeth of the comb into the thread of the piece until you find the one that fits perfectly. With the step identified, it is much easier to follow the measurement and confirm the correct standard."
                ]}
            />

            <TextCaption

                paragraph="And the best part: together with the caliper, the screw comb forms an unbeatable duo when it comes to identifying connections with confidence."
            />

            <TextCaption
                title="Thread Table: a guide always at hand"
                paragraph="After measuring the diameter and pitch of the thread, it's time to tap everything with a thread chart. This table brings the main standards used in the hydraulic industry, with measurements, types of thread and applications. It's like a map that helps you cross-reference the information you've just collected with the options available on the market."
            />

            <TextCaption

                paragraph="Here at HANSA-FLEX, we have our own table, made based on the most common threads we encounter on a daily basis. This helps a lot to speed up identification and gives more security to those who are serving in the field or in the workshop."
            />

            {/* {button to add} */}
            <TextCaption
                title='"Important Information" Guide: Our Ace up Our Sleeve'
                paragraph="This is one of our behind-the-scenes secrets. The 'Important Information' material was created by our technical team to make life easier (and a lot!) for those who are trying to find out which piece it is."
            />


            <TextCaption

                paragraph="Start with simple but fundamental questions: is the piece male or female? Is there Oring? Does it have a sealing cone or flat face? Is it straight or curved? Based on this, check the most likely codes. And look, in practice, this saves a lot of time."
            />

            <TextCaption

                paragraph="For instance:"
                bulletPoints={[
                    "Did you see a 24° cone and an Oring in the female? Great chance of being a DIN connection (codes such as AOL or HL).;",
                    "60° or 74° cone? It can be a JIC or BSP (AJ, HJ, AB, HB).",
                    "Flat face with Oring? Bet on an ORFS (AJF, HJOF).",
                ]}
            />

            <TextCaption
                paragraph="This material also provides tips for differentiating conical and parallel threads, looking at the finish of the part and the shape of the seal. It organizes the identification process by probability and prevents you from falling into the mistake of relying only on appearance."
            />
            {/* {button to add} */}
            <ImageDescription
                imageSrc={imgMeasurement_02}

                paragraphs={[
                    "After measuring the diameter and pitch of the thread, it's time to tap everything with a thread chart. This table brings the main standards used in the hydraulic industry, with measurements, types of thread and applications. It's like a map that helps you cross-reference the information you've just collected with the options available on the market."
                    , "Here at HANSA-FLEX, we have our own table, made based on the most common threads we encounter on a daily basis. This helps a lot to speed up identification and gives more security to those who are serving in the field or in the workshop."
                ]}
            />

            <TextCaption
                title='Pen and Paper: the classic that never fails'
                paragraph="It may seem obvious, but writing down the measurements you take is a habit that avoids rework and confusion. Especially when you serve many clients or work with different types of systems."
            />

            <TextCaption

                paragraph="Always have a notebook or technical sheet at hand and record:"
                bulletPoints={[
                    "Spigot diameter;",
                    "Thread Inner Diameter",
                    "Pitch or number of wires per inch",
                    "Probable Part Code",
                ]}
            />

            <TextCaption
                paragraph="Over time, this becomes a knowledge base that helps you to be increasingly agile and assertive. In addition, organized notes help when it comes to consulting old pieces, placing orders, and even training new colleagues."
            />


            <ImageDescription
                imageSrc={imgMeasurement_03}
                title='To be a coach is also to be an observer'
                paragraphs={["More than knowing how to use the tools, a good professional learns to look carefully. Starting with the appearance of the part, using the logic of the most likely codes, and only then measuring accurately is what makes all the difference in the field."
                ]}
            />

            <TextCaption
                paragraph="At HANSA-FLEX, we believe that technique and method go hand in hand. That's why we invest in training, share exclusive materials such as 'What can it be?' and encourage the use of the right tools from the first service. The result? Fewer errors, more confidence, and excellent technical service."
            />

            <TextCaption
                paragraph="If you want to excel in hydraulics, you don't need to reinvent the wheel. Start with the basics — and do it well. Having a good caliper, a reliable thread comb, an up-to-date table and a technical eye already puts you one step ahead."
            />

            <TextCaption
                title="Want to dig even deeper?"
                paragraph="At HANSA-FLEX, we believe that technical knowledge is what transforms professionals into experts. If you want to learn in practice how to identify connections, correctly use measurement tools and answer all your questions with those who understand the subject, our training is for you."
            />

            <TextCaption
                paragraph="Contact our team and learn how to participate in HANSA-FLEX technical training."
            />

            <TextCaption
                paragraph="Just call on WhatsApp, call or send an email — we'll help you take the next step!"
            />

        </div>

    )
}

export default Measurement